import { Component, HostListener, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { AppState } from "src/app/store/app.reducer";
import { StandardNewValidator, StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { Observable } from "rxjs";
import { Lang } from "src/app/model/lang";
import { DEFAULT_LANG, LANGUAGES } from "src/app/conf/languages";
import { selectCurrentLang, selectRatingLoading } from "src/app/store/user/user.selector";
import { FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Rating } from "src/app/model/rating";
import * as UserActions from 'src/app/store/user/user.actions';
import packageJson from 'package.json';

@Component({
	templateUrl: './rating-dialog.component.html',
})

export class RatingDialogComponent implements OnInit {
	rating: Rating = new Rating;
	ratingForm: FormGroup;

	ratingLoading: boolean;
	ratingLoading$: Observable<boolean | undefined>;
	// ratingSuccess: boolean;
	// ratingSuccess$: Observable<boolean | undefined>;

	currentLang$: Observable<Lang> = new Observable();
	currentLang: Lang = DEFAULT_LANG;
	languages = LANGUAGES;

	// design
	screenWidth: number;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.buildForm();
		this.onResize();
	}

	initSelectors(): void {
		this.currentLang$ = this.store.select(selectCurrentLang);
		this.ratingLoading$ = this.store.select(selectRatingLoading);
		// this.ratingSuccess$ = this.store.select(selectRatingSuccess);
	}

	buildForm(): void {
		this.ratingForm = new FormGroup({
			'ratingValue': new FormControl(this.rating.Rating, [Validators.required, Validators.max(5)]),
			'text': new FormControl(this.rating.Text)
		});
	}

	subscribeAll(): void {
		this.currentLang$?.subscribe((lang: Lang) => {
			this.currentLang = lang;
		});
		this.ratingLoading$?.subscribe((ratingLoading) => {
			this.ratingLoading = ratingLoading;
		});
		// this.ratingSuccess$?.subscribe((ratingSuccess) => {
		// 	this.ratingSuccess = ratingSuccess;
		// });
	}

	get f(): any {
		return this.ratingForm.controls;
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.ratingForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.ratingForm.get(key).errors;
			if (controlErrors != null) {
				Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				});
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void {
		const ratingValue = this.f.ratingValue.value;
		const text = this.f.text.value;
		this.store.dispatch(UserActions.setRatingVote({ ratingValue: ratingValue, text: text, appVersion: packageJson.version }));
		this.ref.close();
	}

	goToForm() {
		let validatedUrl = new URL("https://docs.google.com/forms/d/e/1FAIpQLSf_yK_LIqx9iDCrE5gFQUBh34y-_BlGfVpvmH6G-ghjCKywRA/viewform");
		if (this.currentLang.code === 'it-IT') {
			validatedUrl = new URL("https://forms.gle/bRkLoR8HG69z1DPn6");
		}
		window.open(validatedUrl.toString(), "_blank");
	}

	closeAndRememberAfter(): void {
		this.store.dispatch(UserActions.setRatingVote({ ratingValue: 0, text: '', appVersion: packageJson.version }));
		this.ref.close();
	}

	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicButtonWidth(): string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}
}